<template>
  <el-dialog :visible="showModal" :fullscreen="true" center :close-on-click-modal="false" :show-close="false">

    <el-row>
      <pdf v-for="i in numPages" :key="i" :src="src" :page="i" style="display: inline-block; height: 90%; width: 100%;">
      </pdf>
    </el-row>
    <div class="btns_container">
      <el-tooltip effect="dark" content="Você será deslogado!" placement="bottom">
        <el-button type="danger" @click="refuseTerms">RECUSAR TERMOS DE USO</el-button>
      </el-tooltip>
      <el-button type="primary" @click="accepTerms">ACEITAR TERMOS DE USO</el-button>
    </div>

  </el-dialog>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import { mapActions } from "vuex";
import pdf from 'vue-pdf'

export default {
  name: "AcceptTermsModal",

  components: {
    pdf
  },

  data() {
    return {
      src: undefined,
      numPages: undefined
    }
  },

  mounted() {
    const loadingTask = pdf.createLoadingTask(this.termsUrl)
    this.src = loadingTask
    loadingTask.promise.then(pdf => {
      this.numPages = pdf.numPages;
    });
  },

  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    termsUrl: {
      type: String,
      required: true
    }
  },

  methods: {
    ...mapActions("auth", ["logout"]),
    refuseTerms() {
      this.logout();
      this.$emit('update:showModal', false);
    },

    accepTerms() {
      UserService.acceptTerms()
        .then((res) => {
          console.log(res);
          this.$emit('update:showModal', false);
        })
        .catch((err) => console.log(err))
    }
  },
};
</script>

<style>
.btns_container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 60%;
  margin: 0 auto;
  padding-bottom: 3rem;
}
</style>
